import { usePektaStore } from "../helpers/state";
import { PektaForm } from "./pektaForm";
import { PektaForm2 } from "./pektaForm2";
import { PektaForm3 } from "./pektaForm3";
import { PektaForm4 } from "./pektaForm4";
import { PektaForm5 } from "./pektaForm5";

const PektaParent = () => {
  const { page } = usePektaStore();
  switch (page) {
    case 1:
      return <PektaForm />;
    case 2:
      return <PektaForm2 />;
    case 3:
      return <PektaForm3 />;
    case 4:
      return <PektaForm4 />;
    case 5:
      return <PektaForm5 />;
    default:
      return <PektaForm s />;
  }
};

export default PektaParent;
